import styled from "styled-components";
import indiciimage from '../../assets/images/security.png'
export const StyledDiv=styled.div`
    background-image: url('${indiciimage}');
    background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
   padding: 30px;
`